// extracted by mini-css-extract-plugin
export default {"header":"AuthFormHeader_header__C1xNY","logoWrap":"AuthFormHeader_logoWrap__1Nr86"};